import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/colorants';

export const findColorants = async (company) => {
    return await sendFetch(`${BASE_PATH}/all-colorants/company/${company}`, GET_OPTIONS);
}

export const createColorant = async (body) => {
    return await sendFetch(`${BASE_PATH}/create-colorant`, POST_OPTIONS, body);
}

export const updateColorant = async (body) => {
    return await sendFetch(`${BASE_PATH}/update`, POST_OPTIONS, body);
}

export const deleteColorant = async (body) => {
    return await sendFetch(`${BASE_PATH}/delete`, POST_OPTIONS, body);
}
